import { TravelerAvailableDocumentTypes } from 'common/graphql/__generated__/TravelerAvailableDocumentTypes';
import React from 'react';
import { TravelerDetails_traveler } from '../../../__generated__/TravelerDetails';
import { useFormContext } from 'react-hook-form';
import { TravelerValues } from '../../../interfaces';
import { AttachFormModal } from './AttachFormModal';

interface AttachFormProps {
  availableDocumentTypes: TravelerAvailableDocumentTypes | undefined;
  traveler: TravelerDetails_traveler;
}

export const AttachForm: React.FC<AttachFormProps> = ({
  traveler,
  availableDocumentTypes,
}) => {
  const {
    formState: { isDirty },
  } = useFormContext<TravelerValues>();

  return (
    <AttachFormModal
      traveler={traveler}
      availableDocumentTypes={availableDocumentTypes}
      isDirty={isDirty}
    />
  );
};
